var swiper_reviews = new Swiper(".reviews-carousel", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 10,
    modifier: 8,
    slideShadows: false
  },
  autoplay: {
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
    delay: 3500
  },
  loop: true,
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  // Pagination dots
  pagination: {
    el: ".swiper-pagination",
  },
  keyboard: {
    enabled: true
  },
  breakpoints: {
    768: {
      slidesPerView: 3
    }
  },
});
